import { useRef } from "react";
import { RotateCw } from "lucide-react";

export const FxTransformBox = ({ fx, onChange }) => {
  const box = useRef(null);
  const drag = useRef(null);

  const begin = (mode) => (e) => {
    e.stopPropagation();
    e.currentTarget.setPointerCapture(e.pointerId);
    const wrap = box.current.parentElement.getBoundingClientRect();
    const cx = wrap.left + wrap.width * (0.5 + fx.x / 2), cy = wrap.top + wrap.height * (0.5 - fx.y / 2);
    drag.current = { mode, wrap, cx, cy, x0: e.clientX, y0: e.clientY, fx0: { ...fx },
      d0: Math.hypot(e.clientX - cx, e.clientY - cy) || 1, a0: Math.atan2(e.clientY - cy, e.clientX - cx) };
  };
  const move = (e) => {
    const d = drag.current;
    if (!d) return;
    if (d.mode === "move") {
      const c = (v) => +Math.max(-1.5, Math.min(1.5, v)).toFixed(3);
      onChange({ x: c(d.fx0.x + ((e.clientX - d.x0) / d.wrap.width) * 2), y: c(d.fx0.y - ((e.clientY - d.y0) / d.wrap.height) * 2) });
    } else if (d.mode === "scale") {
      onChange({ scale: +Math.min(3, Math.max(0.05, (d.fx0.scale * Math.hypot(e.clientX - d.cx, e.clientY - d.cy)) / d.d0)).toFixed(3) });
    } else {
      const a = Math.atan2(e.clientY - d.cy, e.clientX - d.cx);
      let rot = d.fx0.rot + ((a - d.a0) * 180) / Math.PI;
      rot = ((rot + 540) % 360) - 180;
      onChange({ rot: +(e.shiftKey ? Math.round(rot / 15) * 15 : rot).toFixed(1) });
    }
  };
  const end = () => (drag.current = null);
  const handlers = { onPointerMove: move, onPointerUp: end };

  return (
    <div ref={box} data-testid="fx-transform-box" onPointerDown={begin("move")} {...handlers}
      className="absolute z-40 border border-[#EC4899] cursor-move touch-none shadow-[0_0_0_1px_rgba(0,0,0,0.6)]"
      style={{ left: `${50 + fx.x * 50}%`, top: `${50 - fx.y * 50}%`, width: `${fx.scale * 100}%`, height: `${fx.scale * 100}%`,
        transform: `translate(-50%, -50%) rotate(${fx.rot}deg)` }}>
      <span className="absolute left-1/2 top-1/2 w-2 h-2 -ml-1 -mt-1 rounded-full bg-[#EC4899]" />
      {[["-left-1.5 -top-1.5"], ["-right-1.5 -top-1.5"], ["-left-1.5 -bottom-1.5"], ["-right-1.5 -bottom-1.5"]].map(([pos], i) => (
        <span key={i} onPointerDown={begin("scale")} {...handlers} data-testid={`fx-scale-handle-${i}`}
          className={`absolute ${pos} w-3 h-3 bg-white border border-[#EC4899] cursor-nwse-resize`} />
      ))}
      <span onPointerDown={begin("rotate")} {...handlers} data-testid="fx-rotate-handle"
        className="absolute left-1/2 -top-7 -ml-2.5 w-5 h-5 rounded-full bg-[#EC4899] text-white flex items-center justify-center cursor-grab">
        <RotateCw className="w-3 h-3" />
      </span>
    </div>
  );
};
